import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const shoesApi = createApi({
  reducerPath: 'shoesApi',
  tagTypes: ['Wishlist'],
  baseQuery: fetchBaseQuery({
    baseUrl: Craft.baseUrl,
    prepareHeaders: (headers) => {
      headers.set('Accept', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addToWishlist: builder.mutation({
      invalidatesTags: ['Wishlist'],
      query: ({ elementId, sessionInfo }) => {
        const body = new FormData();
        body.append('action', `wishlist/items/add${Craft.trailingSlashes ? '/' : ''}`);
        body.append(sessionInfo.csrfTokenName, sessionInfo.csrfTokenValue);
        body.append('elementId', elementId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
    removeFromWishlist: builder.mutation({
      invalidatesTags: [{ type: 'Wishlist' }],
      query: ({ elementId, sessionInfo }) => {
        const body = new FormData();
        body.append('action', `wishlist/items/remove${Craft.trailingSlashes ? '/' : ''}`);
        body.append(sessionInfo.csrfTokenName, sessionInfo.csrfTokenValue);
        body.append('elementId', elementId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  }),
});

export const {
  useAddToWishlistMutation,
  useRemoveFromWishlistMutation,
} = shoesApi;
